module.exports = __webpack_public_path__ + "img/littleBoyHandColor.59795db3.png";